import Vue from "vue";
import Router from "vue-router";
import auth from "@/middleware";
// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Login = () => import("@/views/pages/Login");
const HomeIndex = () => import("@/views/pages/home/Index");
const ReportIndex = () => import("@/views/pages/report/Index");
const PointIndex = () => import("@/views/pages/point/Index");
const CustomerIndex = () => import("@/views/pages/customer/Index");
const NewCustomer = () => import("@/views/pages/customer/register/NewCustomer");
const RegisterSuccess = () => import("@/views/pages/customer/register/Success");
const ProspectIndex = () => import("@/views/pages/customer/prospect/Index");
const PrivilegedIndex = () => import("@/views/pages/customer/privileged/Index");
const CreateSaleOrderIndex = () =>
  import("@/views/pages/saleOrder/CreateSaleOrder");
const SaleOrderIndex = () => import("@/views/pages/saleOrder/Index");
const SaleOrderDetail = () => import("@/views/pages/saleOrder/Detail");
const EmployeeIndex = () => import("@/views/pages/employee/Index");
const RedeemIndex = () => import("@/views/pages/redeem/Index");
const MissionIndex = () => import("@/views/pages/mission/Index");
// const RedeemHistoryIndex = () => import("@/views/pages/redeem/History");
// const RedeemHistoryDetail = () => import("@/views/pages/redeem/HistoryDetail");
const InventoryIndex = () => import("@/views/pages/inventory/Index");
const RequestPurchaseIndex = () =>
  import("@/views/pages/requestPurchase/Index.vue");
const RequestPurchaseDetail = () =>
  import("@/views/pages/requestPurchase/detail");
const RepairProductIndex = () =>
  import("@/views/pages/repairProduct/index.vue");
const RepairProductDetail = () =>
  import("@/views/pages/repairProduct/detail.vue");
const BuyBackIndex = () => import("@/views/pages/buyBack/index.vue");
const BuyBackDetail = () => import("@/views/pages/buyBack/detail.vue");
const ReportPointBalanceIndex = () =>
  import("@/views/pages/report/pointBalance/Index");
const ReportRefSaleMemberIndex = () =>
  import("@/views/pages/report/refSaleMember/Index");
const ReportSpaUsageHistoryIndex = () =>
  import("@/views/pages/report/spaUsageHistory/Index");
const ReportOutstandingIndex = () =>
  import("@/views/pages/report/outstanding/Index");
const ReportHistorySaleCategoryIndex = () =>
  import("@/views/pages/report/historySaleCategory/Index");
const TransactionIndex = () => import("@/views/pages/transaction/Index");
const TransactionDetail = () => import("@/views/pages/transaction/Detail");
const TransactionErrorIndex = () =>
  import("@/views/pages/transactionError/Index");
const TransactionErrorDetail = () =>
  import("@/views/pages/transactionError/Detail");
const SummaryIndex = () => import("@/views/pages/summary/Index");
const SpaIndex = () => import("@/views/pages/spa/Index");
const Register = () => import("@/views/pages/register/Index");
const TimeChange = () => import("@/views/pages/change-time/Index");
const InventoryTransfer = () => import("@/views/pages/inventoryTransfer");
const InventoryTransferDetail = () =>
  import("@/views/pages/inventoryTransfer/detail");
const Deposit = () => import("@/views/pages/deposit");
const CreateDeposit = () => import("@/views/pages/deposit/create.vue");
const DetailDeposit = () => import("@/views/pages/deposit/detail.vue");
const consignmentIndex = () =>
  import("@/views/pages/InvoiceConsignment/index.vue");
const consignmentCreate = () =>
  import("@/views/pages/InvoiceConsignment/create.vue");
const consignmentDetail = () =>
  import("@/views/pages/InvoiceConsignment/detail.vue");
const consignmentCnIndex = () => import("@/views/pages/consignment/index.vue");

const consignmentCnDetail = () =>
  import("@/views/pages/consignment/detail.vue");
const InventoryCheck = () => import("@/views/pages/inventoryCheck");
const InventoryCheckDetail = () =>
  import("@/views/pages/inventoryCheck/detail");

const gpIndex = () => import("@/views/pages/gpConsignment/index.vue");
const gpCreate = () => import("@/views/pages/gpConsignment/create.vue");
const gpDetail = () => import("@/views/pages/gpConsignment/detail.vue");
const ProductIndex = () => import("@/views/pages/product/index.vue");
const ProductDetail = () => import("@/views/pages/product/detail.vue");
Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/account/*",
      name: "",

      meta: { requiresIsLogin: true },
      redirect: "/",
    },
    {
      path: "*",
      name: "Page404",
      redirect: "/",
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/customer/new-customer",
      name: "ลูกค้าใหม่",
      component: NewCustomer,
      meta: {
        requiresAuth: true,
        isChildren: true,
        activeUrl: "/customer",
        lv: 2,
      },
    },
    {
      path: "/customer/success",
      name: "ลงทะเบียนสำเร็จ",
      component: RegisterSuccess,
      meta: {
        requiresAuth: true,
        isChildren: true,
        activeUrl: "/customer",
        lv: 2,
      },
    },
    {
      path: "/Customer/NewCustomer",
      name: "ลูกค้าใหม่",
      component: NewCustomer,
      meta: {
        // requiresAuth: true,
        isChildren: true,
        activeUrl: "/customer",
        lv: 2,
      },
    },
    {
      path: "/",
      redirect: "/home",
      name: "หน้าแรก",
      component: TheContainer,
      meta: { requiresAuth: true, lv: 1, activeUrl: "/home" },
      children: [
        {
          path: "home",
          redirect: "/home",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "หน้าแรก",
              component: HomeIndex,
              meta: {
                requiresAuth: true,
                isFullScreen: true,
                isChildren: true,
                activeUrl: "/home",
                lv: 2,
              },
            },
          ],
        },

        {
          path: "/register",
          name: "ลงทะเบียน",
          component: Register,
          meta: {
            requiresAuth: true,
            lv: 1,
            activeUrl: "/register",
          },
        },
        {
          path: "/time",
          name: "เปลี่ยนเวลา",
          component: TimeChange,
          meta: {
            requiresAuth: true,
            lv: 1,
            activeUrl: "/time",
          },
        },

        {
          path: "spa",
          redirect: "/spa",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "หน้าแรก",
              component: SpaIndex,
              meta: {
                requiresAuth: true,
                isFullScreen: true,
                isChildren: true,
                activeUrl: "/spa",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "report",
          redirect: "/report",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "point-balance",
              name: "เช็คคะแนน",
              component: ReportPointBalanceIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
            {
              path: "ref-sale-member",
              name: "ประวัติการซื้อ",
              component: ReportRefSaleMemberIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
            {
              path: "spa-usage-history",
              name: "ประวัติการใช้",
              component: ReportSpaUsageHistoryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
            {
              path: "outstanding",
              name: "Outstanding",
              component: ReportOutstandingIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
            {
              path: "history-sale-category",
              name: "ประวัติการซื้อแบ่งตามประเภทสินค้า",
              component: ReportHistorySaleCategoryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
            {
              path: "",
              name: "ประวัติการสั่งซื้อ",
              component: ReportIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/report",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "point",
          redirect: "/point",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ประวัติคะแนนสะสม",
              component: PointIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/point",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "customer",
          redirect: "/customer",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "privileged",
              name: "ลูกค้าที่ได้รับสิทธิพิเศษ (Customer Privileged)",
              component: PrivilegedIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/customer",
                lv: 2,
              },
            },
            {
              path: "prospect",
              name: "ลูกค้าที่ไม่มีประวัติการซื้อ (Prospect)",
              component: ProspectIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/customer",
                lv: 2,
              },
            },
            {
              path: "purchase-history",
              name: "ลูกค้าที่มีประวัติการซื้อ",
              component: CustomerIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/customer",
                lv: 2,
              },
            },
            {
              path: "",
              name: "ลูกค้า",
              component: CustomerIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/customer",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "create-sale-order",
          redirect: "/create-sale-order",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สร้างรายการขาย",
              component: CreateSaleOrderIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/create-sale-order",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "sale-order",
          redirect: "/sale-order",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการการขาย",
              component: SaleOrderIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/sale-order",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "รายละเอียดการขาย",
              component: SaleOrderDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/sale-order",
                lv: 3,
              },
            },
          ],
        },
        {
          path: "employee",
          redirect: "/employee",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "info",
              name: "ข้อมูลพนักงาน",
              component: EmployeeIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/employee",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "redeem",
          redirect: "/redeem",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "แลกของรางวัล",
              component: RedeemIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/redeem",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "mission",
          redirect: "/mission",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Membership Activity",
              component: MissionIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/redeem",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "inventory",
          redirect: "/inventory",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "จัดการคลังสินค้า",
              component: InventoryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "request-purchase",
          redirect: "/request-purchase",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สั่งผลิตสินค้าเพื่อเติมสต็อก",
              component: RequestPurchaseIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/request-purchase",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "สั่งผลิตสินค้าเพื่อเติมสต็อก",
              component: RequestPurchaseDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/request-purchase",
                lv: 3,
              },
            },
          ],
        },
        {
          path: "deposit",
          redirect: "/deposit",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สั่งผลิตสินค้าเพื่อเติมสต็อก",
              component: Deposit,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/deposit",
                lv: 2,
              },
            },
            {
              path: "create",
              name: "สั่งผลิตสินค้าเพื่อเติมสต็อก",
              component: CreateDeposit,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/deposit",
                lv: 3,
              },
            },
            {
              path: "detail/:id",
              name: "รายละเอียดการมัดจำ",
              component: DetailDeposit,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/deposit",
                lv: 3,
              },
            },
          ],
        },
        {
          path: "repair-product",
          redirect: "/repair-product",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รับซ่อม",
              component: RepairProductIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/repair-product",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "รับซ่อม",
              component: RepairProductDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/repair-product",
                lv: 3,
              },
            },
          ],
        },
        {
          path: "buy-back",
          redirect: "/buy-back",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ซื้อคืนสินค้า",
              component: BuyBackIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/buy-back",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "ซื้อคืนสินค้า",
              component: BuyBackDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/buy-back",
                lv: 3,
              },
            },
          ],
        },
        {
          path: "transaction",
          redirect: "/transaction",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการขาย",
              component: TransactionIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/transaction",
                lv: 2,
              },
            },
            {
              path: "detail/:id/:userGuid/:showOther",
              name: "รายละเอียดรายการขาย",
              component: TransactionDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/transaction",
                lv: 2,
              },
            },
            {
              path: "detail/:id/:userGuid",
              name: "รายละเอียดรายการขาย",
              component: TransactionDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/transaction",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "transaction-error",
          redirect: "/transaction-error",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "รายการขาย",
              component: TransactionErrorIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/transaction-error",
                lv: 2,
              },
            },
            {
              path: "detail/:id/:userGuid/:showOther",
              name: "รายละเอียดรายการขาย",
              component: TransactionErrorDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/transaction",
                lv: 2,
              },
            },
            {
              path: "detail/:id/:userGuid",
              name: "รายละเอียดรายการขาย",
              component: TransactionErrorDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/transaction-error",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "summary",
          redirect: "/summary",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สรุปยอดขายประจำเดือน",
              component: SummaryIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/summary",
                lv: 2,
                isFullScreen: true,
              },
            },
          ],
        },
        {
          path: "inventory-transfer/:id",
          redirect: "/inventory-transfer",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ข้อมูลพนักงาน",
              component: InventoryTransfer,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory-transfer",
                lv: 2,
              },
            },
            {
              path: "detail/:detail_id",
              name: "ข้อมูลพนักงาน",
              component: InventoryTransferDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory-transfer",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "inventory-transfer/:id",
          redirect: "/inventory-transfer",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "ข้อมูลพนักงาน",
              component: InventoryTransfer,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory-transfer",
                lv: 2,
              },
            },
            {
              path: "detail/:detail_id",
              name: "ข้อมูลพนักงาน",
              component: InventoryTransferDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/inventory-transfer",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "invoice-consignment",
          redirect: "/invoice-consignment",
          name: "คลังตั้งยอด",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Invoice - ตั้งยอด",
              component: consignmentIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,

                activeUrl: "/invoice-consignment",
                lv: 2,
              },
            },
            {
              path: ":id",
              name: "Invoice - ตั้งยอด",
              component: consignmentCreate,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/inventory-consignment",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "Invoice - ตั้งยอด",
              component: consignmentDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/inventory-consignment",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "inventory-check",
          redirect: "/inventory-check",
          name: "นับสต๊อก",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "นับสต๊อก",
              component: InventoryCheck,
              meta: {
                requiresAuth: true,
                isChildren: true,

                activeUrl: "/inventory-check",
                lv: 2,
              },
            },

            {
              path: "detail/:id",
              name: "นับสต๊อก",
              component: InventoryCheckDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                // isFullScreen: true,
                activeUrl: "/inventory-check",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "cn-consignment",
          redirect: "/cn-consignment",
          name: "ลดหนี้",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "CN - ลดหนี้",
              component: consignmentCnIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,

                activeUrl: "/cn-consignment",
                lv: 2,
              },
            },

            {
              path: "detail/:id",
              name: "CN - ลดหนี้",
              component: consignmentCnDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/cn-consignment",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "gp-consignment",
          redirect: "/gp-consignment",
          name: "ส่งห้างประจำวัน",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Tax - ส่งห้างประจำวัน",
              component: gpIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,

                activeUrl: "/gp-consignment",
                lv: 2,
              },
            },
            {
              path: ":id",
              name: "Tax - ส่งห้างประจำวัน",
              component: gpCreate,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/gp-consignment",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "Tax - ส่งห้างประจำวัน",
              component: gpDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/gp-consignment",
                lv: 2,
              },
            },
          ],
        },
        {
          path: "product",
          redirect: "/product",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "สินค้า",
              component: ProductIndex,
              meta: {
                requiresAuth: true,
                isChildren: true,
                activeUrl: "/product",
                lv: 2,
              },
            },
            {
              path: "detail/:id",
              name: "รายละเอียดสินค้า",
              component: ProductDetail,
              meta: {
                requiresAuth: true,
                isChildren: true,
                isFullScreen: true,
                activeUrl: "/product",
                lv: 2,
              },
            },
          ],
        },
      ],
    },
  ],
});
router.beforeEach(async (to, from, next) => {
  const context = {
    from,
    next,
    router,
    to,
  };

  if (to.meta.requiresAuth || to.meta.guestAuth) {
    const middleware = to.meta.requiresAuth ? auth : guestAuth;
    return await middleware({ ...context });
  }
  next();
});
export default router;
